/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Category_PrintersInputs */

const he_home_category_printers = /** @type {(inputs: Home_Category_PrintersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מדפסות`)
};

const en_home_category_printers = /** @type {(inputs: Home_Category_PrintersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Printers`)
};

/**
* | output |
* | --- |
* | "Printers" |
*
* @param {Home_Category_PrintersInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const home_category_printers = /** @type {((inputs?: Home_Category_PrintersInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Category_PrintersInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_home_category_printers(inputs)
	return en_home_category_printers(inputs)
});